import React, { useState } from "react";
import marketpulseMain from "assets/market_pulse_main.svg";
import demoVideo from "assets/videos/Market_Pulse.mp4";
import CONSTANTS from "constants/constants";
import { Button } from "antd";
import { WatchVideoIcon } from "common/icons";
import DemoVideoModal from "common/DemoVideoModal";

const { MARKET_PULSE } = CONSTANTS;

const HeaderSection = () => {
  const [demoVideoModal, setDemoVideoModal] = useState(false);

  return (
    <header className="marketpulse-header">
      {demoVideoModal && (
        <DemoVideoModal
          demoVideoModal={demoVideoModal}
          onChangeDemoVideo={(view) => setDemoVideoModal(view)}
          demoVideo={demoVideo}
        />
      )}
      <div className="marketpulse-header-left">
        <div className="dvt-section-header pt2">
          <span className="marketpulse-title-highlight">
            {MARKET_PULSE.HEADER_TITLE_HIGHLIGHT}
          </span>
          {MARKET_PULSE.HEADER_TITLE}
        </div>
        <div className="marketpulse-header-desc dvt-section-text fw-500 mt1">
          <div>{MARKET_PULSE.HEADER_DESC_1}</div>
          <div>{MARKET_PULSE.HEADER_DESC_2}</div>
          <div>{MARKET_PULSE.HEADER_DESC_3}</div>
          <div className="pt2">{MARKET_PULSE.HEADER_DESC_4}</div>
        </div>
        <Button
          className="watch-button mt1"
          onClick={() => setDemoVideoModal(true)}
        >
          <WatchVideoIcon className="watch-button-icon" />
          <span className="ml1">Quick Tour</span>
        </Button>
      </div>
      <div className="marketpulse-header-right">
        <img src={marketpulseMain} alt="MarketPulse" />
      </div>
    </header>
  );
};

export default HeaderSection;
